<template>
  <div>
   <v-card tile style="min-height: 580px">
          <v-toolbar card dark color="green">
            <v-toolbar-title>Avaliação da evidência </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text class="px-1">

            <v-container fluid class="px-0">
              <v-layout row flex wrap>
                <v-flex xs12 lg6 class="pb-3 px-2">
                  <fade-transition :duration="500">
                    <evidencia
                      :moreopts="false"
                      :image = "aluno[0].profilePic"
                      :evidencia = "evidencia" 
                      />
                  </fade-transition>
                </v-flex>
                <v-flex xs12 lg6 class="px-2">
                  <div style="text-align: center; width: 100%;" v-if="waiting">
                    
                  <v-progress-circular indeterminate 
                  align-center
                  :size="50" 
                  style="text-align: center"
                  color="primary" 
                  v-if="waiting"
                  ></v-progress-circular>
                  </div>
                  
                  <v-card 
                  v-for="classif in classificacoes"
                   :key="classif.name">
                   <v-card-title primary-title 
                   :class="corTitulo(classif.name)"
                   >
                  {{classif.name}}
                   </v-card-title>
                   <v-card-text>

                    <div v-for="grupo in classif.grupos" :key="grupo.name">
                    <div class="headline">{{grupo.name}}</div>
                      <div v-for="(subgrupo, index) in grupo.subgrupos" :key="subgrupo.name">

                        <v-subheader > {{subgrupo.name}} </v-subheader>
                        

                        <v-list three-line
                        v-for="criterio in subgrupo.criterios" :key="criterio.id"
                        > <div ref="obs" :id="'criterio-' + criterio.id"></div> 
                        <v-list-tile-content  >
                            <v-container >
                              <v-layout row wrap>
                                <v-flex xs12 sm6 style="" class="pb-2">
                                <v-header > {{criterio.name}}
                                </v-header>
                                </v-flex>
                                <v-flex xs12 sm6 style="text-align: right; display: inline " class="pb-2" justify-end>
                                  <div v-if="autoAval.length > 0">
                                    <div v-if="criterio.id === autoAval[0].criterio.id">
                                      <rate :length="4"
                                      :readonly="true"
                                      v-model="autoAval[0].valor"
                                      />
                                    </div>
                                  </div>

                                  <div v-if="$store.state.selectedRole.name === 'Aluno'">
                                    <rate :length="4"
                                    :readonly="true"
                                    v-model="criterio.valor"
                                    :ratedesc="[criterio.rubrica_1.description, 
                                    criterio.rubrica_2.description, 
                                    criterio.rubrica_3.description, 
                                    criterio.rubrica_4.description]"
                                    @after-rate="rated(criterio)"
                                    />
                                  </div>
                                  <div v-else>
                                    <rate :length="4"
                                    v-model="criterio.valor"
                                    :ratedesc="[criterio.rubrica_1.description, 
                                    criterio.rubrica_2.description, 
                                    criterio.rubrica_3.description, 
                                    criterio.rubrica_4.description]"
                                    @after-rate="rated(criterio)"
                                    />
                                  </div>
                                </v-flex>

                              </v-layout>
                            </v-container>
                            

                          <v-list-tile-sub-title v-if="criterio.valor" >
                          <v-container fluid>
                          <v-layout row wrap>
                            <v-flex sm12>
                              <v-textarea class="mt-0"
                                v-if="$store.state.selectedRole.name === 'Aluno'"
                                name="comentario"
                                label="Comentário"
                                readonly
                                placeholder="Coloque um comentário sobre a evidência."
                                v-model="criterio.comentario"
                                v-show="criterio.valor"
                                @change="commented(criterio)"
                                :rows="3"
                              ></v-textarea>
                              <v-textarea class="mt-0"
                                v-else
                                name="comentario"
                                label="Comentário"
                                placeholder="Coloque um comentário sobre a evidência."
                                v-model="criterio.comentario"
                                v-show="criterio.valor"
                                @change="commented(criterio)"
                                :rows="3"
                              ></v-textarea>
                            </v-flex>
                          </v-layout>
                          </v-container>
                          </v-list-tile-sub-title>
                        </v-list-tile-content>
                        </v-list>

                        <v-divider v-if="index != grupo.subgrupos.length -1"></v-divider>
                      </div>
                    </div>
                    <v-flex xs12 style="position: absolute;
                              right: 0; margin-top: 15px">
                      <div v-if="activeBtn">
                        <v-tooltip top v-if="$store.state.selectedRole.name !== 'Aluno'">  
                          <v-btn
                            dark
                            fab
                            small
                            slot="activator"
                            color="green"
                            @click.native="avaliarepublicar()"
                          >
                            <v-icon>public</v-icon>
                          </v-btn>
                          <span>Avaliar e publicar</span>
                        </v-tooltip>
                        <v-tooltip top v-if="$store.state.selectedRole.name !== 'Aluno'">              
                          <v-btn
                            fab
                            dark
                            small
                            slot="activator"
                            color="indigo"
                            @click.native="avaliar()"
                          >
                            <v-icon>school</v-icon>
                          </v-btn>
                          <span>Avaliar</span>
                        </v-tooltip>
                        <v-tooltip top v-if="$store.state.selectedRole.name !== 'Aluno'">  
                          <v-btn
                            fab
                            dark
                            small
                            slot="activator"
                            color="amber"
                            @click.native="dialog_criterios = true"
                          >
                            <v-icon>add</v-icon>
                            
                          </v-btn>
                          <span>Adicionar critérios</span>
                        </v-tooltip>
                        <v-tooltip top>
                          <v-btn
                            fab
                            dark
                            small
                            color="red"
                            slot="activator"
                            @click.native="gotoprojec"
                          >
                            <v-icon>reply</v-icon>
                            
                          </v-btn>
                          <span>Voltar sem salvar</span>
                        </v-tooltip>
                      </div>
                      <div v-else>
                        <v-tooltip top v-if="$store.state.selectedRole.name !== 'Aluno'">  
                          <v-btn
                            dark
                            fab
                            icon
                            disabled
                            small
                            slot="activator"
                            color="green"
                            @click.native="avaliarepublicar()"
                          >
                            <v-icon>public</v-icon>
                          </v-btn>
                          <span>Faça um comentário para avaliar e publicar</span>
                        </v-tooltip>
                        <v-tooltip top v-if="$store.state.selectedRole.name !== 'Aluno'">              
                          <v-btn
                            fab
                            dark
                            icon
                            disabled
                            small
                            slot="activator"
                            color="indigo"
                            @click.native="avaliar()"
                          >
                            <v-icon>school</v-icon>
                          </v-btn>
                          <span>Faça um comentário para avaliar</span>
                        </v-tooltip>
                        <v-tooltip top v-if="$store.state.selectedRole.name !== 'Aluno'">  
                          <v-btn
                            fab
                            dark
                            small
                            icon
                            disabled
                            slot="activator"
                            color="amber"
                            @click.native="dialog_criterios = true"
                          >
                            <v-icon>add</v-icon>
                            
                          </v-btn>
                          <span>Faça um comentário para adicionar critérios</span>
                        </v-tooltip>
                        <v-tooltip top>
                          <v-btn
                            fab
                            dark
                            small
                            color="red"
                            slot="activator"
                            @click.native="gotoprojec"
                          >
                            <v-icon>reply</v-icon>
                            
                          </v-btn>
                          <span>Voltar sem salvar</span>
                        </v-tooltip>
                      </div>
                    </v-flex>
                   </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
            
          </v-card-text>

          <div style="flex: 1 1 auto;"></div>

          <!-- Criterios -->
          <v-dialog v-model="dialog_criterios" >
            <v-tabs
              v-model="tab"
              centered
              color="primary"
              dark
              icons-and-text
            >
              <v-tabs-slider color="yellow"></v-tabs-slider>

              <v-tab href="#principal">
                Principais
                <v-icon>bookmark</v-icon>
              </v-tab>

              <v-tab href="#todos">
                Todos
                <v-icon>select_all</v-icon>
              </v-tab>

            </v-tabs>

            <v-tabs-items v-model="tab">
              <v-tab-item id="principal" >
                <show-criterio
                style="width: 100%"
                :criterios="habilidades"
                :solicitacao="solicitacao"
                :titulo="false"
                :botaosaved="botaosaved"
                @saved="criteriosSelecionados"
                @scrool="scroll">
                </show-criterio>
              </v-tab-item>

              <v-tab-item id="todos" >
                <input-criterios-aval 
                  :criterios="criterios"
                  @saved="criteriosSelecionados"
                  @scrool="scroll">
                  </input-criterios-aval>
              </v-tab-item>
            </v-tabs-items>
      
          </v-dialog>
          <v-snackbar
            :timeout="2000"
            color="success"
            v-model="snackbar"
          >
            Avaliado com Sucesso!
          </v-snackbar>
        </v-card>

          <v-dialog v-model="dialog" persistent max-width="290">
            <v-card>
              <v-card-title class="dialogTitle" >Atenção!</v-card-title>
                <v-spacer></v-spacer>
              <v-card-text>Ao voltar pelo navegador, as alterações não serão salvas.</v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" flat @click.native="dialog = false">OK</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import Evidencia from '@/components/reusable/evidencia.vue'
import InputCriteriosAval from '@/components/reusable/inputCriteriosAval.vue'
import ShowCriterio from '@/components/reusable/showCriterio.vue';
import Rate from '@/components/reusable/Rate.vue'
import {FadeTransition} from 'vue2-transitions'
// import * as easings from 'vuetify/es5/util/easing-patterns'

export default {
  components: {
    Evidencia,
    Rate,
    InputCriteriosAval,
    ShowCriterio,
    FadeTransition
  },
  props: {

  },
  data () {
    return {
      dialog_criterios: false,
      mouseY: 0,
      mouseX: 0,
      popuocount: 0,
      animationaval: false,
      animationpub: false,
      fab: false,
      tab: 'principal',
      botaosaved: true,
      solicitacao: true,
      criterios: [],
      autoAval: [],
      classificacoes: [],
      dialog: false,
      activeBtn: false,
      evidencia: {},
      waiting: false,
      rolar: false,
      obs: [],
      aluno: {},
      aval_post: [],
      snackbar: false,
      criterios_selecionados: []
      // easing: 'linear',
      // easings: Object.keys(easings)
    }
  },
  mounted () {
    this.waiting = true
    if (this.$store.state.evid === undefined || this.$store.state.evid === null) {
      var evidid = this.$route.params.id
      api.request('GET', 'evidencias/' + evidid + '/').then(resp => {
        this.evidencia = resp.data
      }).then(reponse => {
        this.getcriterio()
      })
    } else {
      this.evidencia = this.$store.state.evid
      this.getcriterio()
      this.getAutoAval()
    }
    this.pickHabilidade()
    // console.log('atividade', this.$store.state.atividades)
    if (this.$store.state.atividades.length === 0) {
      this.tab = 'todos'
    }
    document.addEventListener('mousemove', e => {
      this.mouseY = e.clientY
      this.mouseX = e.clientX
    })
    this.$watch('mouseY', () => {
      if (this.mouseY < 15) {
        if (this.popuocount < 1) {
          this.dialog = true
          this.popuocount = 1
        }
      }
    })
    this.$watch('mouseX', () => {
      if (!this.dialog_criterios) {
        if (this.mouseX < 145) {
          if (this.popuocount < 1) {
            this.dialog = true
            this.popuocount = 1
          }
        }
      }
    })
  },
  computed: {
    adaptiveFloatingClass () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return ''
        case 'sm': return ''
        case 'md': return ''
        case 'lg': return 'flutuante'
        case 'xl': return 'flutuante'
      }
    },
    permissao (id) {
      if (id === this.autoAval[0].id) {
        return true
      } else {
        return false
      }
    },
    beforeDestroy () {
      this.$store.commit('SET_EVID', null)
    },
    checkComentario () {
      for (let index = 0; index < this.aval_post.length; index++) {
        if (this.aval_post[index].comentario !== '') {
          this.activeBtn = true
        } else {
          this.activeBtn = false
        }
      }
    }
  },
  methods: {
    getMore () {
      if (this.links.next) {
        // this.waiting = true
        api.request('GET', this.links.next, null, null, true).then(response => {
          // this.waiting = false
          this.criterios = this.criterios.concat(response.data.results)
          this.links = response.data.links
          this.filtraAvaliados()
          if (this.links.next) {
            this.getMore()
          }
        })
      }
    },
    getcriterio () {
      api.request('GET', 'users/?username=' + this.evidencia.author).then(response => {
        this.aluno = response.data
      }).then(resp => {
        api.request('GET', 'criterioavaliado/?aluno=' +
                      this.aluno[0].id +
                      '&evidencia=' +
                      this.evidencia.id).then(response => {
                        this.waiting = false
                        this.criterios = response.data.results
                        // console.log('this', this.criterios)
                        this.links = response.data.links
                        this.getMore()
                        this.filtraAvaliados()
                        if (!(this.evidencia.status === 'F' ||
                              this.evidencia.status === 'A' ||
                              this.evidencia.status === 'S' ||
                              this.$store.state.selectedRole.name === 'Aluno')) {
                          this.dialog_criterios = true
                        }
                      })
      })
    },
    filtraAvaliados () {
      var avaliados = this.criterios.filter(criterio => {
        return criterio.newest != null
      })
      avaliados.forEach(val => {
        var newval = {
          ...val,
          valor: val.newest.valor,
          comentario: val.newest.comentario
        }
        this.criterios_selecionados.push(newval)
        this.criteriosSelecionados(this.criterios_selecionados, false)
      })
    },
    showing () {
      this.$nextTick(this.$refs.um.focus)
    },
    getAutoAval () {
      api.request('GET', 'avaliacao/?aluno__username=' + this.evidencia.author + '&evidencia__id=' + this.evidencia.id)
        .then(resp => {
          this.autoAval = resp.data.filter(aval => {
            return (aval.auto_avaliado === true)
          })
          // console.log('auto', this.autoAval)
        })
    },
    pickHabilidade () {
      this.habilidades = []
      for (let index = 0; index < this.$store.state.atividades.length; index++) {
        this.habilidades = this.habilidades.concat(this.$store.state.atividades[index].habilidades)
      }
      this.atualizar = true
      // console.log('aqui', this.habilidades)
    },
    scroll () {
      setTimeout(() => {
        var obs = this.$refs.obs
        location.href = '#' + (obs[obs.length - 1].id)
        // console.log(this.obs[this.obs.length - 1].id)
      }, 500)
    },
    avaliar () {
      this.animationaval = true
      api.request('POST', 'avaliacao/', this.aval_post).then(response => {
        this.snackbar = true
        api.request('GET', 'evidencias/' + this.evidencia.id + '/').then(response => {
          this.evidencia = response.data
          this.$emit('avaliado', this.evidencia)
          this.animationaval = false
          let name = '/projetos/' + this.evidencia.project
          this.$router.push(name)
        }
        )
      })
    },
    avaliarepublicar () {
      this.animationpub = true
      var status = 'F'
      // console.log('aval post', this.aval_post)
      api.request('POST', 'avaliacao/', this.aval_post).then(response => {
        api.request('PATCH', 'evidencias/' + this.evidencia.id + '/', {
          status: status
        }).then(response => {
          this.snackbar = true
          this.animationpub = false
          let name = '/projetos/' + this.evidencia.project
          this.$router.push(name)
        })
      })
    },
    gotoprojec () {
      let name = '/projetos/' + this.evidencia.project
      this.$router.push(name)
    },
    corTitulo (name) {
      if (name.toLowerCase() === 'mundo') {
        return 'mundo'
      } else if (name.toLowerCase() === 'indivíduo') {
        return 'individuo'
      } else if (name.toLowerCase() === 'sociedade') {
        return 'sociedade'
      } else {
        return ''
      }
    },
    commented (criterio) {
      if (criterio.comentario !== '') {
        this.activeBtn = true
      }
      var postados = this.aval_post.filter(aval => {
        return aval.criterio === criterio.id
      })
      if (postados.length <= 0) {
        this.aval_post.push(
          {
            valor: criterio.valor,
            comentario: criterio.comentario,
            aluno: this.aluno[0].id,
            mediador: this.$store.state.user.id,
            evidencia: this.evidencia.id,
            criterio_pk: criterio.id
          }
        )
      } else {
        postados[0].comentario = criterio.comentario
      }
    },
    rated (criterio) {
      var avaliados = this.aval_post.filter(aval => {
        return aval.criterio === criterio.id
      })
      if (avaliados.length <= 0) {
        this.aval_post.push(
          {
            valor: criterio.valor,
            comentario: '',
            aluno: this.aluno[0].id,
            mediador: this.$store.state.user.id,
            evidencia: this.evidencia.id,
            criterio_pk: criterio.id
          }
        )
      } else {
        avaliados[0].valor = criterio.valor
      }
    },
    criteriosSelecionados (value, close = true) {
      if (close) {
        this.dialog_criterios = false
      }
      this.criterios_selecionados = value
      this.activeBtn = false
      this.formataCriterios()
      this.criaArrayClassif()
    },
    formataCriterios () {
      function compare (a, b) {
        if (a.classificacao < b.classificacao) {
          return -1
        } else if (a.classificacao > b.classificacao) {
          return 1
        } else {
          if (a.grupo < b.grupo) {
            return -1
          } else if (a.grupo > b.grupo) {
            return 1
          } else {
            if (a.subgrupo < b.subgrupo) {
              return -1
            } else if (a.subgrupo > b.subgrupo) {
              return 1
            } else {
              if (a.name < b.name) {
                return -1
              } else if (a.name > b.name) {
                return 1
              } else {
                return 0
              }
            }
          }
        }
      }

      this.criterios_selecionados.sort(compare)
    },
    criaArrayClassif () {
      this.criterios_selecionados.forEach(crit => {
        var found = this.classificacoes.filter(el => {
          return el.name === crit.classificacao
        })
        if (found.length <= 0) {
          this.classificacoes.push({
            name: crit.classificacao,
            grupos: [
              { name: crit.grupo,
                subgrupos: [
                  {
                    name: crit.subgrupo,
                    criterios: [
                      crit
                    ]
                  }
                ]}
            ]
          })
        } else {
          var found2 = found[0].grupos.filter(el => {
            return el.name === crit.grupo
          })
          if (found2.length <= 0) {
            found[0].grupos.push({
              name: crit.grupo,
              subgrupos: [
                {
                  name: crit.subgrupo,
                  criterios: [
                    crit
                  ]
                }
              ]

            })
          } else {
            var found3 = found2[0].subgrupos.filter(el => {
              return el.name === crit.subgrupo
            })
            if (found3.length <= 0) {
              found2[0].subgrupos.push(
                {
                  name: crit.subgrupo,
                  criterios: [
                    crit
                  ]
                }
              )
            } else {
              var found4 = found3[0].criterios.filter(el => {
                return el.name === crit.name
              })
              if (found4.length <= 0) {
                found3[0].criterios.push(
                    crit
                )
              } else {

              }
            }
          }
        }
      })
    }

  }
}
</script>
<style lang="css" scoped>
.individuo{
  background-color: #006EFF;
  color: #fff;
}
.sociedade{
  background-color: #FFA300;
  color: #fff;
}
.mundo{
  background-color: #39DF18;
  color: #fff;
}
.autoAval{
  background-color: rgb(174, 179, 174);
  color: #fff;
}
.flutuante{
  position: 
  fixed; 
  top: 180px; 
  width:30%;
  margin-left: 3%;
}
.dialogTitle {
  color: rgb(243, 218, 75);
  font-weight: 500;
  font-size: 2rem;
  margin-left: 25%;
}
#create .v-speed-dial {
  position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Projetos/Avaliacao.vue